import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
import { toPlainText } from '../../../services/rich-content';
function isServiceDropdown(submission) {
  const {
    fieldType,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.SERVICES_DROPDOWN && (typeof value === 'string' || value === null);
}
export function formatServiceDropdown(submission) {
  if (isServiceDropdown(submission)) {
    return {
      label: toPlainText(submission.field.view.label),
      value: submission.value
    };
  }
  return undefined;
}
//# sourceMappingURL=service-dropdown-preview.js.map